import React from 'react'
import { SearchableEntity } from './SelectEntitiesForm.types'
import { ProvideFetchedEntities } from './ProvideFetchedEntities'
import { FetchEntitiesFromBackend } from './FetchEntitiesFromBackend'
import { SearchableItemTypesEnum } from 'shared/enums/common'
import {
  CustomEntitiesLoader,
  FetchEntitiesFromBackendWithCustomQuery
} from './FetchEntitiesFromBackendWithCustomQuery'

export type ProvideEntitiesProps = {
  entities?: SearchableEntity[] | null
  entityType: SearchableItemTypesEnum | string
  loadEntities?: CustomEntitiesLoader
}

export const ProvideEntities: React.FC<ProvideEntitiesProps> = ({
  entities,
  entityType,
  loadEntities,
  children
}) => {
  if (entities) {
    return (
      <ProvideFetchedEntities entities={entities}>
        {children}
      </ProvideFetchedEntities>
    )
  }
  if (loadEntities) {
    return (
      <FetchEntitiesFromBackendWithCustomQuery loadEntities={loadEntities}>
        {children}
      </FetchEntitiesFromBackendWithCustomQuery>
    )
  }
  return (
    <FetchEntitiesFromBackend
      entityType={entityType as SearchableItemTypesEnum}
    >
      {children}
    </FetchEntitiesFromBackend>
  )
}
